var _circle, _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutsOnTheWayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 30,
    cy: 30.4771,
    r: 30,
    fill: "#A4D7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 44.8548H21.6654C16.6654 44.8548 13.332 42.3548 13.332 36.5215V24.8548C13.332 19.0215 16.6654 16.5215 21.6654 16.5215H38.332C43.332 16.5215 46.6654 19.0215 46.6654 24.8548V36.5215C46.6654 42.3548 43.332 44.8548 38.332 44.8548Z",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 25.6878H14.9987C19.9987 25.6878 21.6654 24.0212 21.6654 19.0212V17.3545",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6654 25.6878H44.9987C39.9987 25.6878 38.332 24.0212 38.332 19.0212V17.3545",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 35.688H14.9987C19.9987 35.688 21.6654 37.3547 21.6654 42.3547V44.0213",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6654 35.688H44.9987C39.9987 35.688 38.332 37.3547 38.332 42.3547V44.0213",
    stroke: "#3876BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24681_29931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4985 26.6493C34.4896 26.5345 34.4413 26.4222 34.3536 26.3344C34.2103 26.1912 34.0018 26.153 33.8238 26.2199L23.8348 29.7161C23.6413 29.7838 23.5088 29.9628 23.5004 30.1676C23.4921 30.3725 23.6096 30.5616 23.7969 30.6449L28.1212 32.5668L30.0431 36.8911C30.1264 37.0784 30.3155 37.1959 30.5204 37.1876C30.7252 37.1792 30.9042 37.0467 30.9719 36.8532L34.4684 26.8633C34.494 26.7946 34.5041 26.7215 34.4985 26.6493ZM32.0971 27.8837L25.3555 30.2433L28.3893 31.5916L32.0971 27.8837ZM29.0964 32.2987L32.8043 28.5908L30.4447 35.3325L29.0964 32.2987Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24681_29931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(23 25.688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutsOnTheWayIcon);
export default __webpack_public_path__ + "static/media/PayoutsOnTheWayIcon.8c8866fdcf31cb0a3cc95f891f6dfc9e.svg";
export { ForwardRef as ReactComponent };